export class Traducible {
  id: number;
  traducciones: any;

  constructor(params = null) {
    this.id = 0;
    this.traducciones = {};

    if (params) {
      this.id = params.id;
      this.traducciones = params.traducciones;
    }
  }
}
